export const BANNER_COMPONENT_ID = 'PaymentMethodsBanner';
export const BANNER_BUNDLE_FILE_NAME = 'payment-methods-banner';
export const ARTIFACT_NAME = 'payment-methods-banner';
export const ARTIFACT_GROUP_ID = 'com.wixpress';
export const FULL_ARTIFACT_ID = `${ARTIFACT_GROUP_ID}.${ARTIFACT_NAME}`;
